import RoadmapComponent from "./RoadmapComponent";
import "./index.css"

export default function PageSeven() {

    return (
        <div class="text-light">
            <h1 className="text-center">Roadmap</h1>
            <div className="page-seven-background">
            <div class="row">
                <div class="col">
                    <RoadmapComponent time={"2022 Q4"} text={["Team setup", "Lepton DAO setup"]} />
                </div>
                <div class="col">
                    <RoadmapComponent time={"2023 Q1"} text={["Seed round fundraising", "Token launches on testnet",
                    "Webset launches", "Begin Airdrop campaign"]}/>
                </div>
                <div class="col">
                    <RoadmapComponent time={"2023 Q2"} text={["Token launches on main chains", "DAPP launches", "NFT marketplace opens"]}/>
                </div>
            </div>
                <br/>
            <div class="row">
                <div class="col">
                    <RoadmapComponent time={"2023 Q3"} text={["Token ICO", "1st consensus meeting", "1st Lepton Crypto music competition"]}/>
                </div>
                <div class="col">
                    <RoadmapComponent time={"2023 Q4"} text={["1st Online music festival", "Launch Lepton artist funding scheme"]}/>
                </div>
                <div class="col">
                    <RoadmapComponent time={"2024 Q1"} text={["2nd consensus meeting", "Fund 100 next-generation crypto artists"]}/>
                </div>
            </div>
            </div>
        </div>
    )
}